import React from "preact";

function CloseIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path fill="#333" d="M11.156 9.999l5.86-6.984a.177.177 0 00-.137-.293H15.1a.364.364 0 00-.275.127L9.99 8.611 5.158 2.849a.357.357 0 00-.274-.127H3.103a.178.178 0 00-.137.293l5.86 6.984-5.86 6.984a.177.177 0 00.137.293h1.78a.363.363 0 00.275-.128l4.833-5.76 4.833 5.76c.066.08.167.128.274.128h1.781a.177.177 0 00.136-.293L11.156 10z"></path>
    </svg>
  );
}

export default CloseIcon;
